import {
  createAction,
  createActionGroup,
  emptyProps,
  props,
} from '@ngrx/store';
import { MfaMethod } from '@fantaz/shared/data-access/api';
import {
  FetchMFAPreferenceOutput,
  UpdateMFAPreferenceInput,
} from 'aws-amplify/auth';

export const changeTotpMfaPreference = createAction(
  '[EnableMfa Page] change Totp Mfa Preference',
);

export const updateMFAPreferenceMfa = createAction(
  '[EnableMfa Page] Update EnableMfa',
  props<{ updateMFAPreference: UpdateMFAPreferenceInput }>(),
);

export const updateEnableMfaSuccess = createAction(
  '[EnableMfa/API] Update EnableMfa Success',
  props<{ updateMFAPreference: UpdateMFAPreferenceInput }>(),
);

export const UpdateEnableMfaFailure = createAction(
  '[EnableMfa/API] Update EnableMfa Failure',
  props<{ error: any }>(),
);

// This code block defines a group of actions related to Multi-Factor Authentication (MFA) preferences in the authentication module.
// 'Load MfA Preference' is dispatched to initiate the loading of MFA preferences.
// 'Load MfA Preference Success' is dispatched when the MFA preferences have been successfully loaded. It carries the payload of the fetched preferences.
// 'Load MfA Preference Failure' is dispatched when there is an error loading the MFA preferences. It carries the error as its payload.
export const AuthMFAActions = createActionGroup({
  source: 'Auth/MFAPreference',
  events: {
    'Load MfA Preference': () => emptyProps(),
    'Load MfA Preference Success': (payload: FetchMFAPreferenceOutput) => ({
      payload,
    }),
    'Load MfA Preference Failure': (error: any) => ({ error }),

    'Send MfA Notification': (payload: UpdateMFAPreferenceInput) => ({
      payload,
    }),
    'Send MfA Notification Success': () => emptyProps(),
    'Send MfA Notification Failure': (error: any) => ({ error }),
  },
});

export const AuthenticatorMFAActions = createActionGroup({
  source: 'Auth/AuthenticatorMFA',
  events: {
    'Setup TOTP': () => emptyProps(),
    'Setup TOTP Success': (payload: FetchMFAPreferenceOutput) => ({
      payload,
    }),
    'Setup TOTP Failure': (error: any) => ({ error }),
  },
});
